import { render, staticRenderFns } from "./VerificationMethod.vue?vue&type=template&id=38813da6&scoped=true"
import script from "./VerificationMethod.vue?vue&type=script&lang=js"
export * from "./VerificationMethod.vue?vue&type=script&lang=js"
import style0 from "./VerificationMethod.vue?vue&type=style&index=0&id=38813da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38813da6",
  null
  
)

export default component.exports